import React, { useState , useEffect} from 'react';
import leaderImage from '../img/envision/aerospace/BUTUCHI BABU BURRA.jpeg';  // Import the image file
import BoardOfDirectorsnavbar from './BoardOfDirectorsnavbar';
import { FaLinkedin } from 'react-icons/fa';
import AboutLeadershipsecondcontainer from './AboutLeadershipsecondcontainer';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
const LeadershipDatasecond = () => {
     const location = useLocation();
    
        useEffect(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, [location]); // Run effect when the route changes
        
    return (
        <div>
            <div style={{ background: "rgb(236 115 34)", marginTop: "80px", height: "63px" }}>
                <h1 style={{ textAlign: "center", paddingTop: "13px" }}>OUR LEADERSHIP</h1>
            </div>
            {/* <BoardOfDirectorsnavbar />    */}
            <div style={styles.rowWrapper}>

                <div style={styles.row}>
                    <div style={styles.widgetSpan}>
                        <div id="hs_cos_wrapper_module_1564397675620228" style={styles.hsCosWrapper}>
                            {/* LazySizes Script */}
                            <script src="https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js" async=""></script>

                            <div style={styles.abMembers}>
                                <div style={styles.container}>
                                    <div style={styles.imageColumn}>
                                        <div style={styles.mImage}>
                                            {/* Use the imported image */}
                                            <img
                                                className="ls-is-cached lazyloaded"
                                                src={leaderImage}  // Use the imported image here
                                                alt="Butchi Babu Burra"
                                                style={styles.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={styles.textColumn}>
                                        <h1>Butchi Babu Burra </h1>
                                        <span> Advisory Board Member - BFSI</span>
                                        <br />

                                        {/* LinkedIn Icon */}
                                        <a href="https://www.linkedin.com/in/bbutchibabu/" target="_blank" rel="noopener noreferrer">
                                            <FaLinkedin size={30} color="#0077B5" />
                                        </a>

                                    </div>
                                </div>
                            </div>

                            <div style={styles.memberParagraph}>
                                <div style={styles.container}>
                                    <div style={styles.col12}>
                                        <div style={styles.teamParagraph}>
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px' }}>Dr. Butchi babu Burra, Advisory board member – BFSI, DREBCON  </p>
                                            
                                            <p style={{ textAlign: 'justify', marginTop:'10px' }}>
                                            Butchi Babu is a renowned banking technology and cybersecurity expert with over 35 years of experience in IT, IT security, IT governance, and banking technology. He is very well renowned in the BFSI sector as a IT and security GRC guru and has incredible track record of defining and establishing GRC frameworks across various banks. 
                                            </p>
                                            <p style={{ textAlign: 'justify', marginTop:'10px' }}>With a distinguished career in Bank of India, where he served in key leadership roles including General Manager (IT) & CIO, he has played a pivotal role in shaping IT strategy, cybersecurity frameworks, and digital banking transformations. </p>
                                            <br></br>
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px',  }}>Leadership & Advisory Roles  </p>
                                           
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>
                                            Butchi Babu has been an advisor, mentor, and expert committee member for several 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold' }}>
                                            leading financial institutions, regulatory bodies, and banks:  
                                            </p>
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                {/* <li style={{fontWeight:'bold'}}></li> */}
                                                <li style={{marginLeft:"30px"}}>Member, IT Advisory Board (ITAB) – Punjab and Sind Bank (Since 2021)  </li>
                                                <li style={{marginLeft:"30px"}}>Member, Information Security Steering Committee (ISSC) – Punjab and Sind Bank (Since 2021) </li>
                                                <li style={{marginLeft:"30px"}}>Member, Expert IT Committee – Indian Institute of Banking & Finance (IIBF) (Since 2017) </li>
                                                <li style={{marginLeft:"30px"}}>Expert Panel Member – IBPS (for IT officer recruitment for banks) (Since 2017) </li>
                                                <li style={{marginLeft:"30px"}}>IT & Cybersecurity Consultant – Advisor to over 10 banks, including RBI, NABARD, PSB, UBI, TMB, and IIBF </li>
                                             <li style={{marginLeft:"30px"}}>Mentor, Telangana State Innovation Council (Since 2021) </li>
                                                <li style={{marginLeft:"30px"}}>Startup Mentor, T-Hub, Telangana (Since 2019) </li>
                                              
                                            
                                            </ul>

                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold' }}>
                                            Banking & Technology Expertise 
                                            </p>
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                {/* <li style={{fontWeight:'bold'}}></li> */}
                                                <li style={{marginLeft:"30px"}}>Ex-General Manager (IT) & CIO – Bank of India (2016-2017)  </li>
                                                <li style={{marginLeft:"30px"}}>Ex-Advisor (IT) – Bank of India (2017) </li>
                                                <li style={{marginLeft:"30px"}}>Ex-Senior Domain Expert, IDRBT (2017-2021) </li>
                                                <li style={{marginLeft:"30px"}}>Ex-Member, Technical Advisory Committee, NPCI </li>
                                                <li style={{marginLeft:"30px"}}>Advisor for IT strategy, cybersecurity, and RFP negotiations in multiple banks </li>
                                        
                                            
                                            </ul>
                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold' }}>
                                            Academic & Professional Excellence 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px'}}>Butchi Babu holds a strong academic foundation in Physics, Cyber Law, and Cybersecurity, complemented by prestigious industry certifications: </p>
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                {/* <li style={{fontWeight:'bold'}}></li> */}
                                                <li style={{marginLeft:"30px"}}>M.Sc. in Nuclear Physics – Andhra University (1977-1979)  </li>
                                                <li style={{marginLeft:"30px"}}>Diploma in Cyber Law & Cybersecurity – Asian School of Cyber Laws (2012)  </li>
                                                <li style={{marginLeft:"30px"}}>Certified Information Systems Auditor (CISA)  </li>

                                        
                                            
                                            </ul>
                                        
                                    
                                          


                                         
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', marginTop:'20px'}}>
                                            Academic & Thought Leadership 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>Butchi Babu is a recognized thought leader, author, and speaker in cybersecurity, AI, blockchain, data analytics, and emerging banking technologies: </p>
                                           
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                               
                                                <li style={{marginLeft:"30px"}}><b>Guest Faculty – IIBF, IDRBT, NIBM, RBI,</b> covering IT governance, cybersecurity, AI & ML, blockchain, and data science  </li>
                                                <li style={{marginLeft:"30px"}}><b>Author – Book on Emerging Technologies </b>(IIBF, 2022) </li>
                                                <li style={{marginLeft:"30px"}}><b>Reviewer –</b> Publications for Journal of Banking and Financial Technology, IDRBT  </li>

                                                <li style={{marginLeft:"30px"}}><b>Speaker & Moderator –</b> Over 11 years of engagements in technology forums, banking summits, and industry conferences  </li>
                                                {/* <li style={{marginLeft:"30px"}}><b>CBCP</b> (Certified Business Continuity Professional)  </li> */}

                                            </ul>

                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px' , marginTop:'20px'}}>
                                            Key Contributions to Banking & IT 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>With 27 years in IT leadership roles within Bank of India, Butchi Babu has pioneered IT governance, cybersecurity policies, digital banking initiatives, and core banking system advancements. His expertise in payment systems, IT risk management, regulatory compliance, and emerging banking technologies has made a significant impact in the financial sector. </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>As an Advisory Board Member at DREBCON, Butchi Babu brings unparalleled expertise in IT governance, cybersecurity, and digital transformation, ensuring cutting-edge, AI-driven solutions for banking and financial institutions. </p>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AboutLeadershipsecondcontainer />
            <Footer/>
        </div>
    );
};

const styles = {
    rowWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '46px',
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1200px',
    },
    widgetSpan: {
        padding: '20px',
    },
    hsCosWrapper: {
        marginBottom: '30px',
    },
    abMembers: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '20px',
    },
    container: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },
    imageColumn: {
        flex: 1,
        paddingRight: '20px',
    },
    mImage: {
        width: '100%',
    },
    image: {
        width: '86%',
        borderRadius: '8px',
        border:'1px solid'
    },
    textColumn: {
        flex: 2,
        paddingLeft: '20px',
        display: 'flex',               // Add display flex to enable flexbox layout
        flexDirection: 'column',       // Arrange children in a column
        justifyContent: 'center',     // Vertically center the content
        // alignItems: 'center',       
        // textAlign: 'center',         
    },
    socialLink: {
        display: 'inline-block',
        marginTop: '10px',
    },
    socialIcon: {
        width: '30px',
        height: '30px',
    },
    memberParagraph: {
        padding: '20px',
    },
    col12: {
        width: '100%',
    },
    teamParagraph: {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#333',
        textAlign: 'justify',  // Added text alignment as justify
    },
};

export default LeadershipDatasecond;
